import Model from "../Model";

class BubblesDivison extends Model{

    buildUrl ({ param }) {
        return ['divisionview/getbyid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BubblesDivison;